import * as React from 'react';
import { connect } from 'react-redux';

class NotifyUsofClaimBlock extends React.Component<any, any> {
    public render() {
        return (
            <>
                <div className="fnol-steps-claims-block">
                    <div className="claims-block-inner">
                        <h3>Notify us of a claim</h3>
                        <p>Before we can look into your claim, we need a few details. Remember, incorrect and untruthful info may influence the outcome of your claim</p>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        ssp: state.ssp,
    }
}

export default connect(mapStateToProps)(NotifyUsofClaimBlock);